import React from 'react';
import type { Step, FloaterProps } from 'react-joyride';
import { isDesktop } from '@zola-helpers/client';

import Mp4GifEmulator from 'components/common/ui/Mp4GifEmulator';

import mp4 from 'assets/videos/guestlist/walkthroughMagicLink.mp4';

import styles from '../ManageAddressCollectionLinkTour.module.less';

const Step1Component: React.FC = () => (
  <div>
    <p className={styles.stepCopy}>
      Say hello to your magic link (ooh ahh). Access it anytime under <strong>Guest List</strong>.{' '}
      <span className={styles.hideSm}>Here are a couple more helpful hints.</span>
    </p>
    <Mp4GifEmulator src={mp4} className={styles.gif} />
  </div>
);

const Step1: Step = isDesktop()
  ? {
      target: '.navSecondary__magic-link',
      content: <Step1Component />,
      placement: 'bottom',
      disableBeacon: true,
    }
  : {
      target: 'body',
      content: <Step1Component />,
      disableBeacon: true,
      placement: 'center',
      floaterProps: { hideArrow: true } as FloaterProps,
    };

export default Step1;



// WEBPACK FOOTER //
// ./src/components/manage/guestlist/addressCollection/ManageAddressCollectionLinkTour/Steps/Step1.tsx